export default __webpack_public_path__ + "static/media/ic-file.b875e00d.svg";